import { render } from "./profile-awards.vue?vue&type=template&id=74ac3c9c"
import script from "./profile-awards.vue?vue&type=script&lang=js"
export * from "./profile-awards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__